import styled from "@emotion/styled";

const H2 = styled.h2`
  font-size: 1.25rem;
`;

export default H2;
